// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BOkIMdOUAQVOQk {
  display: flex;
  position: relative;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  width: fit-content;
  max-width: 100%;
  height: 24px;
  margin-bottom: var(--ds-space-050, 4px);
  padding: var(--ds-space-025, 2px);
  border-radius: 3px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
}
.l2mAoxP747LETW:hover {
  cursor: pointer;
  filter: saturate(85%) brightness(85%);
}
.i0a3_aIBK1HcUl {
  background-color: var(--ds-background-accent-green-subtler, #baf3db);
  color: var(--ds-text-accent-green, #216e4e);
}
.i0a3_aIBK1HcUl.IRBlPpAzmf7j9R {
  background-color: var(--ds-background-success-bold, #1f845a);
  color: var(--ds-text-inverse, #ffffff);
}
.z68Y2_7BPHt871 {
  background-color: var(--ds-background-accent-yellow-subtler, #f8e6a0);
  color: var(--ds-text-accent-yellow, #7f5f01);
}
.z68Y2_7BPHt871.IRBlPpAzmf7j9R {
  background-color: var(--ds-background-warning-bold, #e2b203);
  color: var(--ds-text-inverse, #ffffff);
  color: var(--ds-text-warning-inverse, #172b4d);
}
.Xi8PufBLA4_W8x {
  background-color: var(--ds-background-accent-orange-subtler, #ffe2bd);
  color: var(--ds-text-accent-orange, #974f0c);
}
.Xi8PufBLA4_W8x.IRBlPpAzmf7j9R {
  background-color: var(--ds-background-accent-orange-bolder, #b65c02);
  color: var(--ds-text-inverse, #ffffff);
}
.SXKSg0bJSxp1Zx {
  background-color: var(--ds-background-accent-red-subtler, #ffd2cc);
  color: var(--ds-text-accent-red, #ae2a19);
}
.SXKSg0bJSxp1Zx.IRBlPpAzmf7j9R {
  background-color: var(--ds-background-danger-bold, #ca3521);
  color: var(--ds-text-inverse, #ffffff);
}
.P1jBcalA0mmYPA {
  background-color: var(--ds-background-accent-purple-subtler, #dfd8fd);
  color: var(--ds-text-accent-purple, #5e4db2);
}
.P1jBcalA0mmYPA.IRBlPpAzmf7j9R {
  background-color: var(--ds-background-accent-purple-bolder, #6e5dc6);
  color: var(--ds-text-inverse, #ffffff);
}
.r3InB1s3tH8KAS {
  background-color: var(--ds-background-accent-blue-subtler, #cce0ff);
  color: var(--ds-text-accent-blue, #0055cc);
}
.r3InB1s3tH8KAS.IRBlPpAzmf7j9R {
  background-color: var(--ds-background-accent-blue-bolder, #0c66e4);
  color: var(--ds-text-inverse, #ffffff);
}
.ZmwG2PxPuPNYLO {
  background-color: var(--ds-background-accent-teal-subtler, #c1f0f5);
  color: var(--ds-text-accent-teal, #206b74);
}
.ZmwG2PxPuPNYLO.IRBlPpAzmf7j9R {
  background-color: var(--ds-background-accent-teal-bolder, #1d7f8c);
  color: var(--ds-text-inverse, #ffffff);
}
.STb1W9airlULHf {
  background-color: var(--ds-background-accent-magenta-subtler, #fdd0ec);
  color: var(--ds-text-accent-magenta, #943d73);
}
.STb1W9airlULHf.IRBlPpAzmf7j9R {
  background-color: var(--ds-background-accent-magenta-bolder, #ae4787);
  color: var(--ds-text-inverse, #ffffff);
}
.IrtOhLAO6B4dcs {
  background-color: var(--ds-background-accent-lime-subtler, #d3f1a7);
  color: var(--ds-text-accent-lime, #4c6b1f);
}
.IrtOhLAO6B4dcs.IRBlPpAzmf7j9R {
  background-color: var(--ds-background-accent-lime-bolder, #5b7f24);
  color: var(--ds-text-inverse, #ffffff);
}
.BjWFiBX6C_V0Hi {
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
  color: var(--ds-text-accent-gray, #44546f);
}
.xx0xnga5w1fHA_ {
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
  color: var(--ds-text-accent-gray, #44546f);
}
.xx0xnga5w1fHA_.IRBlPpAzmf7j9R {
  background-color: var(--ds-background-accent-gray-bolder, #626f86);
  color: var(--ds-text-inverse, #ffffff);
}
.body-color-blind-mode-enabled .qt9FCKerrLRaYQ {
  padding-left: var(--ds-space-250, 20px);
}
.body-color-blind-mode-enabled .qt9FCKerrLRaYQ::before {
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 16px;
  border-radius: 4px 0 0 4px;
  mask-repeat: repeat-y;
}
.PTI0Jl5N9qIXEm {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  line-height: 20px;
}
.T8p0iZePEoaO1J {
  padding-right: var(--ds-space-050, 4px);
  padding-left: var(--ds-space-025, 2px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.T8p0iZePEoaO1J:first-child {
  padding-left: var(--ds-space-050, 4px);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": `BOkIMdOUAQVOQk`,
	"badge--isInteractive": `l2mAoxP747LETW`,
	"badge--green": `i0a3_aIBK1HcUl`,
	"badge--isBold": `IRBlPpAzmf7j9R`,
	"badge--yellow": `z68Y2_7BPHt871`,
	"badge--orange": `Xi8PufBLA4_W8x`,
	"badge--red": `SXKSg0bJSxp1Zx`,
	"badge--purple": `P1jBcalA0mmYPA`,
	"badge--blue": `r3InB1s3tH8KAS`,
	"badge--sky": `ZmwG2PxPuPNYLO`,
	"badge--pink": `STb1W9airlULHf`,
	"badge--lime": `IrtOhLAO6B4dcs`,
	"badge--gray": `BjWFiBX6C_V0Hi`,
	"badge--black": `xx0xnga5w1fHA_`,
	"badge--hasColorBlindPattern": `qt9FCKerrLRaYQ`,
	"badgeIcon": `PTI0Jl5N9qIXEm`,
	"badgeText": `T8p0iZePEoaO1J`
};
export default ___CSS_LOADER_EXPORT___;
